import { type IStopArea } from '../../../../models/stop-area.model';
import { StopPointApiModel } from './stop-point.api-model';

export class StopAreaApiModel {
  name!: string;
  gid!: string;
  latitude!: number | null;
  longitude!: number | null;
  stopPoints?: StopPointApiModel[];

  public static mapToBusinessModel(apiModel: StopAreaApiModel): IStopArea {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      latitude: apiModel.latitude ?? undefined,
      longitude: apiModel.longitude ?? undefined,
      municipalityName: undefined,
      tariffZone1: undefined,
      tariffZone2: undefined,
      stopPoints: apiModel.stopPoints?.map(StopPointApiModel.mapToBusinessModel) ?? [],
    };
  }
}

